import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import config from "../../../config/config";

/**
 * Generated class for the LiberarDiasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-liberar-dias',
  templateUrl: 'ecliberar-dias.html',
})
export class ecLiberarDiasPage {
  usuario: any;
  grupo: any;
  servicos: any;
  local:any;
  horario:any
  servicoescolhido:any;
  localescolhido:any;
  horariosescolhidos:any = [];
  diasEscolhido:any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public _http: Http,
    private alertCtrl: AlertController,
  ) {
  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.grupo = this.usuario.grupold;
    if (this.usuario.grupold == 2) {
      this.getServico()
    } else {
      this.getServicosOperador()
    }
    this.getLocal()

  }
  getServicosOperador() {
    this._http
    .get(config.urlAPI + "respectivo/servicoEspacocultural/"+this.usuario.id, {})
    // .get(config.urlAPI + "respectivo/servico/15663", {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      this.servicos = res;
    })
    .catch(error => { });
  }
  getServico() {
    this._http
      .get(config.urlAPI + "pesquisar/servicoCultural", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.servicos = res;
      console.log(res)

      })
      .catch(error => { });
  }
  getLocal() {
    this._http
      .get(config.urlAPI + "pesquisar/localCultural", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.local = res;
      })
      .catch(error => { });
  }


  salvar(){
    if (this.diasEscolhido == undefined||this.diasEscolhido == null  || this.localescolhido == undefined||this.localescolhido == null  ||this.servicoescolhido == undefined||this.servicoescolhido == null) {
      let alert = this.alertCtrl.create({
        title: "Por favor",
        subTitle: `Preencha todos os dados`,
        buttons: [
          {
            text: "OK",
            handler: data => {
              // this.ionViewDidLoad()
            }
          }
        ]
      });
      alert.present();
      return true
    }
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    let env={
      dia:this.diasEscolhido,
      servico:this.servicoescolhido,
      local:this.localescolhido
    }
    this.servicoescolhido=null;
    this.localescolhido=null;
    this.horariosescolhidos = [];
    this.diasEscolhido=null;
    this.horario = null;
    this.enviardados(env).then((r)=>{
      loading.dismiss()

    })
  }
  async enviardados(env){

    this._http
    .post(config.urlAPI + "cadastro/diaEspacocultural",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      console.log(res)
      if (res.success == false) {
        let alert = this.alertCtrl.create({
          title: "Error",
          subTitle: `Alteração não realizada pois o dia ja esta cadastrado`,
          buttons: [
            {
              text: "OK",
              handler: data => {
                // this.ionViewDidLoad()
              }
            }
          ]
        });
        alert.present();
      } else {
        let alert = this.alertCtrl.create({
          title: "Sucesso",
          subTitle: "Dia liberado para agendamento",
          buttons: [
            {
              text: "OK",
              handler: data => {
                // this.ionViewDidLoad()
              }
            }
          ]
        });
        alert.present();
      }
      return res;
    })
    .catch(error => { 
      console.log(error)

      return error
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/espaco-cultural/liberar-dias/ecliberar-dias.ts